import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, useStore } from 'react-redux';
import {
    getQuestionnaireTemplate,
    createQuestionnaireTemplateAndCloseDrawer,
    saveQuestionnaireTemplateAndCloseDrawer,
    cloneQuestionnaireTemplateAndCloseDrawer,
    questionnaireTemplateInit,
    questionnaireTemplateClone, setQuestionnaireVersionsModeFlag
} from "../../../actions/questionnaireTemplateActions";
import {notificationOpen} from "../../../actions/notificationActions";
import QuestionnaireEditor from "./QuestionnaireEditorHook";
import {QD_URL} from "../../../constants/systemConstants";
import * as TEMPLATE from "../../../constants/templateConstants";
import {createEditorOrigin, EDITOR_TYPES} from "../../../utilities/editorInstanceOwnership";


const QuestionnaireContainerHook = () => {
    const [templateKey, setTemplateKey] = useState("");
    const [templateId, setTemplateId] = useState(null);
    const [createMode, setCreateMode] = useState(new URL(window.location.href).pathname.split("/")[3] === "");
    const [cloneMode, setCloneMode] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useStore();

    // Redux state selectors
    const questionnaireType = useSelector(state => state.questionnaireEditor.questionnaireType);
    const filter = useSelector(state => state.filter[TEMPLATE.FILTER.current.questionnaire]);
    const versionsFilter = useSelector(state => state.filter[TEMPLATE.FILTER.versions.questionnaire]);
    const questionnaireVersionsModeFlag = useSelector(state => state.questionnaireVersionsModeFlag.flag);

    useEffect(() => {
        const currURL = window.location.href;
        const objURL = new URL(currURL);

        let pathnameArray = objURL.pathname.split("/");
        let resolvedCreateMode = (pathnameArray[3] === ""); // Must be in create mode
        let resolvedTemplateKey = pathnameArray[3];
        let resolvedTemplateId = resolvedCreateMode ? null : parseInt(pathnameArray[4]);
        let resolvedCloneMode = resolvedCreateMode ? false : (pathnameArray[5] === "1"); // Clone mode "0" = false, "1" = true

        if (!resolvedCreateMode) {
            dispatch(getQuestionnaireTemplate(resolvedTemplateKey, resolvedTemplateId));
        }

        setTemplateKey(resolvedTemplateKey);
        setTemplateId(resolvedTemplateId);
        setCreateMode(resolvedCreateMode);
        setCloneMode(resolvedCloneMode);
    }, [dispatch]);

    const saveClone = (templateEditor, options) => {
        if (options.hasError) {
            dispatch(notificationOpen("Validate fields before saving."));
            return;
        }

        let updatedTemplate = {
            ...templateEditor,
            categoryKeys: store.getState().questionnaireEditor.categoryKeys
        };

        // Don't clone any published data
        updatedTemplate.startDate = null;
        updatedTemplate.endDate = null;
        updatedTemplate.notes = "";
        const requestOwner = createEditorOrigin(
            EDITOR_TYPES.QUESTIONNAIRE,
            store.getState().questionnaireEditor.instanceId
        );

        dispatch(questionnaireTemplateClone());
        return dispatch(cloneQuestionnaireTemplateAndCloseDrawer(
            updatedTemplate,
            filter,
            versionsFilter,
            TEMPLATE.MODE.CURRENT,
            navigateToQuestionnaireList,
            requestOwner
        ));
    };

    const save = (templateEditor, options) => {
        dispatch(questionnaireTemplateInit());
        if (options.hasError) {
            dispatch(notificationOpen("Validate fields before saving."));
            return;
        }

        let updatedTemplate = {
            ...templateEditor,
            categoryKeys: store.getState().questionnaireEditor.categoryKeys,
        };
        const requestOwner = createEditorOrigin(
            EDITOR_TYPES.QUESTIONNAIRE,
            store.getState().questionnaireEditor.instanceId
        );

        // -------------------------------------------------------------------------------------------------------------

        if (createMode) {
            updatedTemplate.questionnaireType = questionnaireType;

            return dispatch(createQuestionnaireTemplateAndCloseDrawer(
                updatedTemplate,
                filter,
                navigateToQuestionnaireList,
                requestOwner
            ));
        }
        return dispatch(saveQuestionnaireTemplateAndCloseDrawer(
            updatedTemplate,
            filter,
            versionsFilter,
            TEMPLATE.MODE.CURRENT,
            navigateToQuestionnaireList,
            requestOwner
        ));
    };

    const handleToolbarButtonClick = (event, fieldName, buttonTitle, templateEditor, options) => {
        switch (buttonTitle) {
            case "SAVE":
                if (cloneMode) {
                    return saveClone(templateEditor, options);
                }
                return save(templateEditor, options);
            case "CANCEL":
                navigateToQuestionnaireList();
                break;
            // no default
        }
    };

    const navigateToQuestionnaireList = () => {
        if (questionnaireVersionsModeFlag) {
            dispatch(setQuestionnaireVersionsModeFlag(false));
            navigate(QD_URL + "/questionnaire-versions/" + templateKey, {replace: true});
        } else {
            navigate(QD_URL + "/questionnaires", {replace: true});
        }
    };

    return (
        <div id="QuestionnaireContainer-main-div">
            <div id="QuestionnaireContainer-container-div" style={{padding: "0px 0px", overflow: "visible", marginTop: "64px"}}>
                <QuestionnaireEditor
                    createMode={createMode}
                    cloneMode={cloneMode}
                    templateKey={templateKey}
                    templateId={templateId}
                    handleToolbarButtonClick={handleToolbarButtonClick}
                    width="100%"
                />
            </div>
        </div>
    );
};

QuestionnaireContainerHook.defaultProps = {

};

QuestionnaireContainerHook.propTypes = {

};

export default QuestionnaireContainerHook;